import {
    CLEAR_APP_STATE,
    CLEAR_ORDER_WIZARD, CLEAR_STATE,
    LOAD_RESTAURANTS_IN_ZONE_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_RESTAURANTS_IN_ZONE_SUCCESS:
            return action.payload;
        case CLEAR_ORDER_WIZARD:
            return INITIAL_STATE;
        case CLEAR_STATE:
            if (action.fromPwa) {
                return state;
            } else {
                return INITIAL_STATE;
            }
        case CLEAR_APP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}